import styles from "./mainFigure.module.scss";
import { ThemeContext } from "providers/ThemeProvider";
import { useContext } from "react";

const MainFigure = () => {
  const { hasTheme } = useContext(ThemeContext);

  return (
    <div
      className={`${styles.figureContainer} ${
        hasTheme === "light" ? styles.light : styles.dark
      }`}
    >
      <img
        src={"images/figures/character_v2.png"}
        alt="test"
        className={styles.character}
      />
      <div className={styles.shadow_effect}></div>
    </div>
  );
};

export default MainFigure;
